import "./Footer.css"
import latTwae from "../assets/lattwaelogo.png"
import latTwaeHack from "../assets/lattwaehack.png"
import otopus from "../assets/otopus.png"

const Footer = () => {

    return(
        <div className="Footer">
            <img src={otopus} alt="" id="otopus"/>
            <img src={latTwae} alt="" />
            <img src={latTwaeHack} alt="" />
        </div>
    )
}

export default Footer